import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Logger} from '../utils/logger';
import {Authentication} from '../extension/authentication.extension';
import {StringsService} from '../../../../projects/common/src/lib/services/strings.service';
import {AuthService} from '../services/auth.service';
import {FirebaseApi} from '../services/firebase-api.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ProjectApiService} from '../services/api/routes/project-api.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-signout-component',
  template: `
    <div class="loading-overlay app-background-color flex-col align-center-center">
      <div id="loading-overlay-inner" class="flex-col align-center-center gap-30">
        <div style="margin-bottom: 30px">
          <img src="/assets/images/app-logo.svg" alt="" style="width: 150px; height: 150px;object-fit: contain">
          <h3>{{strings['app_tagline']}}</h3>
        </div>

        @if (failed) {
          <!-- Signing out stopped half way: say so, and offer the ways on.
               Both reload the app, because by now its database connection
               may already be closed. -->
          <div class="signout-failed flex-col align-center-center gap-12" role="alert">
            <p>{{strings['sign_out_failed']}}</p>
            <div class="flex-row gap-12">
              <button mat-flat-button color="primary" type="button" (click)="retry()">{{strings['try_again']}}</button>
              <button mat-stroked-button type="button" (click)="backToDashboard()">{{strings['back_to_dashboard']}}</button>
            </div>
          </div>
        } @else {
          <mat-spinner [diameter]="40" [strokeWidth]="4" color="primary" [attr.aria-label]="strings['sign_out']"></mat-spinner>
        }

        <div>
          <img src="/assets/images/blueblinkone_symbol.svg" alt="" style="width: 40px; height: 40px; object-fit: contain">
          <img src="/assets/images/blueblinkone_vertical.svg" alt="" class="icon" style="width: 40px; height: 40px; object-fit: contain">
        </div>
      </div>
    </div>
  `,
  styles: [`
    .signout-failed { max-width: 320px; padding: 0 16px; text-align: center; }
    .signout-failed p { margin: 0; color: var(--text-secondary); font-size: var(--text-sm); line-height: 1.5; }
  `],
  styleUrls: ['../../app.component.scss', '../../styles/common.scss'],
})
export class SignoutComponent extends Authentication implements OnInit {
  private route = inject(ActivatedRoute);

  /** Signing out failed; the spinner gives way to what to do next. */
  failed = false;

  constructor() {

    super();
  }

  ngOnInit() {
    // Where to go once signed in again (the canvas's Login button sends the
    // project it was on), handed on to the login page, which checks it
    // (LoginComponent.safeRedirect).
    const rdt = this.route.snapshot.queryParamMap.get('rdt');
    this.auth.signOut().then(async result => {
      if (result) {
        await this.router.navigate(['/login'], rdt ? {queryParams: {rdt}} : {});
        window.location.reload();
      }
    }).catch(reason => {
      // It used to leave the spinner turning for good, with only a snackbar.
      Logger.error('Sign-out failed', reason);
      this.failed = true;
    });
  }

  /** Starts sign-out again from a fresh page. */
  retry() {
    window.location.reload();
  }

  backToDashboard() {
    window.location.assign('/dashboard');
  }

}
